export const PAYMENT_HELP_URL = "https://faq.whatsapp.com/167763192262914";
